import cognitoConfig from '../config/cognito';
import { http } from '../http';

export const signup = async (email: string) => {
	const signupResponse = await http.post('auth/signup', { email, client_id: cognitoConfig.cognitoClient }, true);
	return signupResponse
}
